import React from 'react'
import {useQuery} from 'react-query'
import {getProjectsFromInterview} from '../_requets'
import {useAuth} from '../../../modules/auth'
import {Link} from 'react-router-dom'
import {KTIcon} from '../../../../_metronic/helpers'

interface InterviewListProps {
  showAddButton?: boolean
}

const InterviewList = ({showAddButton = true}: InterviewListProps) => {
  const {currentUser} = useAuth()
  const {data: projects, isLoading} = useQuery({
    queryKey: ['projects'],
    queryFn: () =>
      getProjectsFromInterview(
        currentUser?.profileType === 'admin' ? 'all' : currentUser?.fullName
      ),
    enabled: !!currentUser,
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
  })

  return (
    <div className='card'>
      <div className='card-header'>
        <h3 className='card-title'>Interview List</h3>
        <div className='card-toolbar'>
          {currentUser?.profileType === 'admin' && showAddButton && (
            <Link to='/interview/create-interview' className='btn btn-success btn-sm'>
              <KTIcon iconName='plus' className='fs-3' />
              <span className='text-sm md:text-base hidden md:inline'>New Interview</span>
            </Link>
          )}
        </div>
      </div>
      <div className='card-body'>
        {isLoading ? (
          <div className='d-flex align-items-center justify-center'>
            <div className='loader'></div>
          </div>
        ) : (
          <div className='table-responsive'>
            <table className='table align-middle gs-0 gy-3'>
              <thead>
                <tr className='fw-bold text-muted bg-light'>
                  <th className='min-w-25px rounded-start text-center'>No.</th>
                  <th className='min-w-100px text-center'>Project Name</th>
                  <th className='min-w-100px text-center'>No. of Interviews</th>
                </tr>
              </thead>
              <tbody>
                {projects?.map((project, index) => (
                  <tr key={project._id}>
                    <td className='fw-bold text-center'>{index + 1}</td>
                    <td className='ps-8 fw-bold capitalize'>
                      <Link
                        to={
                          showAddButton
                            ? `/interview/${project._id}`
                            : {
                                pathname: `/reports/reportList/${project._id}`,
                                search: `?value=interview`, // Pass option.value as a query parameter
                              }
                        }
                      >
                        {project?.name || ''}
                      </Link>
                    </td>
                    <td className='fw-bold text-center'>{project?.count || 0}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  )
}

export default InterviewList
